import HighlightedText from 'Components/Atoms/HighlightedText/HighlightedText';
import { Icon, ICONS } from 'Components/Atoms/Icon/Icon';
import Tag from 'Components/Atoms/Tag/Tag';
import React, { useEffect, useState } from 'react';
import styles from './DropdownField.module.sass';

const DropdownFieldDropdownItem = ({item, iteration, searchQuery, activeValues, onClick, ...props}: any) => {
    const [state, setState] = useState({
        isOpen: searchQuery?.length > 0,
        iteration: iteration || 0
    });

    useEffect(() => {
        setState({ ...state, isOpen: searchQuery?.length > 0 });
    }, [searchQuery]);

    const handleOpenClick = () => setState({...state, isOpen: !state.isOpen});
    const handleClick = () => onClick(item.id);
    const handleChildClick = (v) => onClick(v);

    if (item.children) {
        return <>
            <div className={`${styles['dropdown__item']}  ${state.isOpen ? styles['dropdown__item--isOpen'] : ''} ${activeValues?.includes(item.id) ? styles['dropdown__item--active'] : ''}`} onClick={handleOpenClick}>
                <div className={styles[`dropdown__item-${state.iteration}`]} />
                
                { props.labels && props.labels[item.id] }

                <div className={styles[`dropdown__item-arrow`]}>
                    <Icon
                        type={ICONS.CHEVRON_DOWN}
                        size={'small'}
                    />
                </div>
            </div>
            {
                state.isOpen && item.children.map((child) => <DropdownFieldDropdownItem
                    key={child.id}
                    item={child}
                    labels={props.labels}
                    iteration={state.iteration+1}
                    activeValues={activeValues}
                    searchQuery={searchQuery}
                    onClick={handleChildClick}
                />)
            }
        </>;
    }
    
    return <div className={`${styles['dropdown__item']} ${activeValues?.includes(item.id) ? styles['dropdown__item--active'] : ''}`} onClick={handleClick}>
        <div className={styles[`dropdown__item-${state.iteration}`]} />

        <div style={{width: '100%', pointerEvents: 'none'}}>
            <HighlightedText highlight={searchQuery || ''}>{props.labels && props.labels[item.id]}</HighlightedText>
        </div>
    </div>;
}

export default DropdownFieldDropdownItem;